import { useI18n } from '../lib/i18n';

// SR / EN / RU — izbor jezika (pamti se; važi i posle prijave)
export default function LangSwitch({ style }) {
  const { lang, setLang } = useI18n();
  return (
    <div style={{ display: 'flex', gap: 4, ...style }} role="group" aria-label="Jezik / Language">
      {['sr', 'en', 'ru'].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className="mono"
          style={{
            minWidth: 38, height: 30, borderRadius: 7, fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', cursor: 'pointer',
            border: '1px solid ' + (lang === l ? 'var(--teal-800)' : 'var(--line)'),
            background: lang === l ? 'var(--teal-800)' : 'var(--surface)',
            color: lang === l ? '#fff' : 'var(--ink-500)',
          }}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
